@if (isCookieBannerVisible()) {
  <div class="banner banner-cookie">
    <div class="banner-icon"><img width="36" height="36" loading="lazy" ngSrc="images/icons/cookie.svg" alt="cookie"></div>
    <div class="banner-content">
      <h4 class="banner-title">{{ 'This website uses cookies' | translate }}</h4>
      <p class="banner-description">{{ 'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking “Accept”, you consent to our' | translate }} 
        <a [routerLink]="language === 'en' ? ['/privacy-policy'] : [language, 'privacy-policy']">{{ 'Privacy Policy' | translate }}</a>
      </p>
    </div>
    <div class="banner-actions">
      <button type="button" (click)="acceptCookie()" class="primary">{{ 'Accept' | translate }}</button>
    </div>
  </div>
}